<template>
  <li
    :data-status="team.status"
    :data-company="team.company"
    :data-filtering="filtering"
    :data-show="team.show"
    v-if="(team && (filtering ? team.show : true) && team.status) || team.company"
    class="team-wrapper">
    <!--    <pre class="text-white text-left">-->
    <!--      sh:{{team.show}}-->
    <!--      st:{{team.status}}-->
    <!--    </pre>-->
    <span class="tf-nc team-container"
          :data-team-id="team.id">
      <span @click.stop.prevent="clickedTeam"
            class="team-block"
            :class="team.show ? 'show' : ''">
        <span class="team-name">{{team.title}}</span>
        <span class="togglechildren"
              v-if="hasVisibleChildTeams"
              @click.stop.prevent="toggleChildren">
          <span class="small score-c-4"><i class="fal fa-sitemap"></i></span>
        </span>
        <span class="border-0 sore"
              v-if="team.vipscore"
              :class="(team.vipscore % 1 > 0 ? 'small' : '') + ` score-cicle team-score score-c-${truncate(team.vipscore, 0)} score-bc-${truncate(team.vipscore, 0)}`">
         {{ truncate(team.vipscore,1)}}
        </span>
        <span class="team-expander"
              @click.stop="showMembers = !showMembers"
              v-if="team.users">
          <span v-if="showMembers" class="small score-c-4"><i class="fal fa-user-minus"></i></span>
          <span v-else class="small score-c-4"><i class="fal fa-user-plus"></i></span>
        </span>
        <span @click.stop.prevent="getTeam(team)"
              v-if="isCurrentTree && !team.company"
              class="team-info score-bc-4 score-c-4 border-0"
              style="cursor:pointer">
          <i class="fal fa-cog"></i>
          <span class="team-info-container" v-if="team.information || team.managedBy">
            <span v-if="team.information" class="mb-2 info">{{team.information}}</span>
            <template v-if="team.managedBy">
              <p class="font-italic small m-0 managers">{{$t('message.managed_by')}}</p>
              <div class="m-0 managers mt-1 d-block text-left">
                <div class="text-left p-0 d-block" v-for="manager in team.managedBy">- {{manager.fullname}}</div>
              </div>
            </template>
          </span>
        </span>
      </span>
      <transition name="teammembers">
<!--        <template v-show="team ? team.users : false">-->
          <span class="team-members pos-rel" v-if="showMembers && (filtering ? hasVisibleMembers : true) && !team.company">

            <p :data-uid="member.id"
               :data-parentid="team.id"
               v-for="member in sortedTeamMembers"
               :data-show="member.show"
               class="team-member justify-content-start"
               :key="member.id"
               v-show="filtering ? member.show : true"
               :class="member.show ? 'show' : ''">
<!--              {{member.show}}-->
              <span
                class="score ml-0 mr-3"
                :class="(member.vipscore % 1 > 0 ? 'small' : '') +` score-circle member-score score-bgc-${truncate(member.vipscore, 0)}  scre-c-${truncate(member.vipscore, 0)} score-bc-${truncate(member.vipscore, 0)}`">
               {{member.vipscore ? truncate(member.vipscore,1) : '--'}}
              </span>
              <span class="u_name text-left">{{member.lastname}} {{member.firstname}}</span>
            </p>
            <p class="small" v-if="team.users.length > memberLimit">
              +{{(team.users.length)-memberLimit}}
            </p>
          </span>
        <!--        </template>-->
      </transition>
    </span>
    <transition name="childteams">
      <ul v-if="showChildren && hasVisibleChildTeams">
        <!--        -->
        <tree :key="child.id"
              :ref="'tree-child-'+child.id"
              v-for="(child,i) in sortedChildTeams"
              @getTeam="getTeam"
              @getUser="getUser"
              @clickedTeam="clickedTeam"
              :tree-type="treeType"
              :filtering="filtering"
              :team="child">
        </tree>
      </ul>
    </transition>
  </li>

</template>
<script>
  import store from "../../store/store";
  import TeamForm from "../Teams/TeamForm";

  export default {
    components: {
      teamForm: TeamForm
    },
    name: 'tree',
    mounted() {
      // if (this.team) {
      //   if (typeof (this.team.users) == 'undefined' || !this.team.users.length) {
      //     this.showMembers = true;
      //   }
      // }
    },
    methods: {
      dragClass(b) {
        let tree = document.getElementsByClassName('team-tree')[0];
        if (b) {
          tree.classList.add('dragging-users-active')
        } else {
          tree.classList.remove('dragging-users-active')
        }
      },

      startCallback(evt) {
        this.dragClass(true)
      },
      updateCallback(evt) {
      },
      endCallback(evt) {
        this.dragClass(false)
      },
      chooseCallback(evt) {
      },
      moveCallback(evt) {
        // let uid = evt.dragged.dataset.uid;
        // let targetUids = [];
        // const targetMembers = evt.to.children;
        //
        // for (var i = 0; i < targetMembers.length; i++) {
        //   targetUids.push(targetMembers[i].dataset.uid);
        // }
        // if (targetUids.includes(uid)) {
        //   return false;
        // }
      },
      changeCallback(evt) {
      },
      endUserDrag(e) {
        let uid = e.item.dataset.uid;
        let movedFromTeamEl = e.from;
        let movedToTeamEl = e.to;
        let from_id = movedFromTeamEl.dataset.parentid;
        let to_id = movedToTeamEl.dataset.parentid;
        if (from_id !== to_id) {
          this.moveUser(uid, from_id, to_id)
        }
      },
      async removeUserFromTeam(user_id, t_id) {
        // let team = null;
        // this.axios.get('/teams/' + t_id).then(res => {
        //   team = res.data;
        //   let members = team.users;
        //   members.forEach((val, ind) => {
        //     if (val.id == user_id) {
        //       members.splice(ind, 1)
        //     }
        //   });
        //   this.axios.put('/teams/' + team.id, {
        //     users: members
        //   }).then(res => {
        //     this.logActivity('Removed team member', 'info (HR)');
        //   });
        // });
      },
      addUserToTeam(uid, t_id, f_id) {
        // let team = null;
        // this.axios.get('/teams/' + t_id).then(res => {
        //   team = res.data;
        //   let members = team.users;
        //   if (!members.includes(uid)) {
        //     members.push(uid);
        //     this.axios.put('/teams/' + t_id, {
        //       users: members
        //     }).then(res => {
        //       this.logActivity('Added team member', 'info (HR)');
        //       this.removeUserFromTeam(uid, f_id);
        //     })
        //   }
        // });
      },
      moveUser(uid, from_id, to_id) {
        this.addUserToTeam(uid, to_id, from_id);
      },
      startDragging() {
        this.dragging(true);
      },
      getUser(id) {
      //  console.log('getuser teamtree')
        this.$emit('getUser', id);
      },
      getTeam(id) {
        if (this.role === 'hr') {
          this.$emit('getTeam', id);
        }
      },
      dragChange(e) {
      },
      dragging(b) {
        let tree = document.getElementsByClassName('team-tree')[0];
        if (b) {
          tree.classList.add('dragging-active')
        } else {
          tree.classList.remove('dragging-active')
        }
      },
      addTeamToCompany(team_id, company_id = null) {
        if (company_id === null) {
          const company = store.getters.getCompany;
          company_id = company.id
        }
        const team_ids = [team_id]
        this.axios.get('/companies/' + company_id).then(c => {
          const company = c.data;
          const teams = company.teams;
          teams.forEach((team, ind) => {
            team_ids.push(team.id);
          })
          this.axios.put('companies/' + company_id, {
            teams: team_ids
          }).then(c => {
            this.logActivity('Edited team', 'info (HR)');
            // console.log('updated company', c)
          })
        })
      },
      endDrag(e, oe) {
        this.dragging(false)
        let team_id = e.item.dataset.teamid;
        let movedFromTeamEl = e.from;
        let movedToTeamEl = e.to;
        let from_id = movedFromTeamEl.dataset.parentid;
        let to_id = movedToTeamEl.dataset.parentid;

        let to_parent = e.to.parentNode;
        let from_parent = e.from.parentNode;


        if (to_parent.dataset.company === 'true') {
          //  console.log('moved to company from', from_id)
          this.removeTeamFromParent(team_id, from_id).then(r => {
            this.addTeamToCompany(team_id, 1)
          })
        } else if (from_parent.dataset.company === 'true') {
          // console.log('moved from company to', to_id)
          this.removeTeamFromParent(team_id, 1, true).then(r => {
            this.addTeamToParent(team_id, to_id)
          })
        } else {

          if (from_id !== to_id) {
            //  console.log('moving team from->to', [from_id, to_id])
            this.moveTeam(team_id, from_id, to_id)
          }
        }
        //if target = company, set this team as child of company, else do below


      },
      toggleChildren() {
        this.showChildren = !this.showChildren;
      },

      // setChildrenTo(state){
      //   this.showChildren = state
      // },
      // setMembersTo(state){
      //   this.showMembers = state
      // },


      async removeTeamFromParent(team_id, parent_id, company = false) {
        //todo dont run if parent = company top level
        let parent = null;
        let req = '/teams/';

        if (company) {
          req = '/companies/';
        }

        return await this.axios.get(req + parent_id).then(async res => {
          parent = res.data;
          let parentTeams = parent.teams;
          parentTeams.forEach((val, ind) => {
            if (val.id == team_id) {
              parentTeams.splice(ind, 1)
            }
          });
          return await this.axios.put(req + parent.id, {
            teams: parentTeams
          }).then(res => {
            //   console.log('remove response', res)
            this.logActivity('Edited team', 'info (HR)');
          });
        });
      },

      addTeamToParent(team_id, parent_id) {
        // //  console.log('adding team to', parent_id)
        // //todo dont run if parent = company top level
        // let parent = null;
        // this.axios.get('/teams/' + parent_id).then(res => {
        //   parent = res.data;
        //   let parentTeams = parent.teams;
        //   if (!parentTeams.includes(team_id)) {
        //     parentTeams.push(team_id);
        //     this.axios.put('/teams/' + parent_id, {
        //       teams: parentTeams
        //     }).then(res => {
        //       this.logActivity('Edited team', 'info (HR)');
        //     })
        //   }
        // });
      },
      clickedTeam() {
        this.$emit('clickedTeam', this.team)
      },
      moveTeam(team_id, from, to) {
        if (team_id !== to && team_id !== from) {
          this.removeTeamFromParent(team_id, from).then(
            res => {
              //  console.log('post remove response', res)
              this.addTeamToParent(team_id, to)
            }
          );
        }
      },
    },
    data() {
      return {
        draggingActive: false,
        managedUsers: [],
        popupOpen: false,
        role: '',
        showChildren: true,
        showMembers: false,
        memberLimit: 5
      }
    },
    created() {
      this.role = store.state.viewMode;
    },
    computed: {
      sortedTeamMembers() {
        let sortedMembers = _.sortBy(this.team.users, [user => user.lastname ? user.lastname.toLowerCase() : user.lastname]);
        if (this.filtering) {
          sortedMembers = _.filter(sortedMembers, user => {return user.show});
        }
        sortedMembers = sortedMembers.slice(0, this.memberLimit);
        return sortedMembers
      },
      sortedChildTeams() {
        let sortedTeams = _.sortBy(this.team.teams, [team => team.title]);
        return sortedTeams
      },
      isCurrentTree() {
        let r = true;
        if (this.filtering) {
          r = false
        }
        return r
      },
      hasVisibleChildTeams() {
        let r = false;
        if (this.team.teams) {
          // console.log('team has child teams');
          this.team.teams.forEach(childteam => {
            // console.log('child', childteam.status)
            if ((this.filtering ? childteam.show : true) && childteam.status) {
              r = true
            }
          })
        }
        return r
      },
      showTeam() {
        return true;
        //todo if filtering by teams managed is needed, re-enable below
        // if (this.treeType === 'manager') {
        //   if (this.team.company) {
        //     return '_company'
        //     return true
        //   } else {
        //     if (this.team.managed) {
        //       if (this.team.teams) {
        //         this.team.teams.forEach(childteam => {
        //           childteam.submanaged = true
        //         })
        //         return '_managed'
        //         return true
        //       } else {
        //         return '_managed'
        //         return true
        //       }
        //     } else if (this.team.submanaged) {
        //       if (this.team.teams) {
        //         this.team.teams.forEach(childteam => {
        //           childteam.submanaged = true
        //         })
        //         return '_submanaged'
        //         return true
        //       } else {
        //         return '_submanaged'
        //         return true
        //       }
        //     } else {
        //       let managedchildren = false;
        //       if (this.team.teams) {
        //         this.team.teams.forEach(childteam => {
        //           if (childteam.managed) {
        //             managedchildren = true
        //           }
        //         });
        //       } else {
        //         return false
        //       }
        //
        //       if (managedchildren) {
        //         return '_parent'
        //         return true
        //       } else {
        //         return false
        //       }
        //     }
        //   }
        // } else {
        //   return '_hrview'
        //   return true
        // }
      },
      dragActive() {
        return this.draggingActive
      },
      hasVisibleMembers() {
        let result = false;
        if(this.team.users){
          this.team.users.forEach(val => {
            if (this.filtering ? val.show : true) {
              result = true
            }
          });
        }
        return result
      },
    },
    props: {
      treeType: {
        type: String,
        default() {
          return 'manager'
        }
      },
      filtering: {
        type: Boolean,
        default() {
          return false
        }
      },
      team: {
        type: Object,
        default() {
          return {
            members: [],
            children: [],
            title: '',
            average: '',
          };
        }
      }
    }
  }
</script>


<style>

  .managed-team > .team-container > span.team-block > .team-name {
    position: relative;
  }

  /*  .managed-team > .team-container > span.team-block > .team-name:before {*/
  /*    content: '*';*/
  /*    display: block;*/
  /*    position: absolute;*/
  /*    right:-8px;*/
  /*    top: -3px;*/
  /*    color: white;*/
  /*  }*/

  /*  .lightmode .managed-team > .team-container > span.team-block > .team-name:before {*/
  /*font-weight:bold;*/
  /*    color: black;*/
  /*  }*/

  .managed-team > .team-container > span.team-block {
    background-color: #343840 !important;
    border-color: #8d8d8d !important;
  }

  .lightmode .managed-team > .team-container > span.team-block {
    background-color: #fafafa !important;
    border-color: #616161 !important;
  }

  /*  .managed-team > .team-container > span.team-block > .team-name:after {*/
  /*    display: block;*/
  /*    position: absolute;*/
  /*    bottom: -3px;*/
  /*    left: 0;*/
  /*    width: 100%;*/
  /*    border-bottom: 1px solid;*/
  /*  }*/


  .managed-icon {
    display: block;
    position: absolute;
    left: -14px;
    top: 50%;
    transform: translateY(-50%);
  }

  .team-block {
    margin-left: 15px;
    margin-right: 15px;
  }

  .tf-tree ul {
    align-items: flex-start;
  }

  .team.dragArea {
    padding: 0;

  }

  /*.team.dragArea {*/
  /*  border: 1px solid red;*/
  /*  background-color: rgba(255, 0, 0, 0.1);*/
  /*}*/

  /*.team-component {*/
  /*  border: 1px solid orange;*/
  /*}*/

  .team li {
    padding: 0;
  }

  @keyframes fadeout {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes fadein {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  .teampopupfade-enter-active {
    animation: fadeout .2s ease-out forwards;
  }

  .teampopupfade-leave-active {
    animation: fadein .2s ease-out forwards;
  }

  .team-members {
    z-index: 0;
    transform-origin: top center;
    overflow: hidden;
  }

  .teammembers-enter-active {
    animation: scale-in .3s ease-out forwards;
  }

  .teammembers-leave-active {
    animation: scale-out .3s ease-out forwards;
  }


  @keyframes grow {
    from {
      opacity: 0;
      max-width: 0px;
    }
    to {
      opacity: 1;
      max-width: 500px;
    }
  }

  @keyframes shrink {
    from {
      opacity: 1;
      max-width: 500px;
    }
    to {
      opacity: 0;
      max-width: 0px;
    }
  }

  .childteams-enter-active {
    animation: teams-in .6s ease-out forwards;
  }

  .childteams-leave-active {
    animation: teams-out .6s ease-out forwards;
  }

  .childteams-enter-active span {
    animation: grow .6s ease-out forwards;
  }

  .childteams-leave-active span {
    animation: shrink .6s ease-out forwards;
  }

  .tf-tree li ul span {
    max-width: 500px;
  }

  .tf-tree li ul {
    position: relative;
    z-index: 0;
  }

  .tf-tree li {
    transition: all .3s;
  }

  li.ct-hidden {
    flex: 0
  }

  li.ct-shown {
    flex: 1
  }

  @keyframes teams-in {
    from {
      /*opacity: 0;*/
      /*top: -100px;*/
    }
    to {
      /*opacity: 1;*/
      /*top: 0;*/
    }
  }

  @keyframes teams-out {
    from {
      /*opacity: 1;*/
      /*top: 0;*/
    }
    to {
      /*opacity: 0;*/
      /*top: -100px;*/
    }
  }

  @keyframes scale-in {
    from {
      flex-grow: .0001;
      opacity: 0;
      top: -100px;
    }
    to {
      flex-grow: 1;
      opacity: 1;
      top: 0;
    }
  }

  @keyframes scale-out {
    from {
      opacity: 1;
      top: 0;
    }
    to {
      opacity: 0;
      top: -100px;
    }
  }


  .u_name {
    white-space: nowrap;
  }

  .togglechildren {
    cursor: pointer;
    position: absolute;
    /*left: 10px;*/
    bottom: 5px;
  }

  .ct-hidden .togglechildren {
    /*transform: rotate(180deg);*/
  }

  li.sortable-drag:before {
    visibility: hidden;
  }


  li.sortable-drag span:before,
  li.sortable-drag span:after {
    visibility: hidden;
  }

  li.sortable-chosen ul {
    /*display: none;*/
    visibility: hidden;
    /*width: 0px;*/
  }

  .team-member {
    font-size: 13px;
  }


</style>



// WEBPACK FOOTER //
// src/components/Tree/TeamTree.vue